import createContext from 'bz-utilities/hooks/context-v2';
import React from 'react';

export const useDialog = (init?: boolean) => {
  const [isOpen, setOpen] = React.useState(init ?? false);

  const open = React.useCallback(() => {
    setOpen(true);
  }, []);

  const close = React.useCallback(async () => {
    setOpen(false);
    // allow short delay for the dialog close animation to finish
    return new Promise((resolve) => setTimeout(() => resolve('some value'), 400));
  }, []);

  return [isOpen, open, close] as const;
};

export type DialogCTX = ReturnType<typeof useDialog>;

export const [DialogContext, useDialogContext] = createContext<DialogCTX>('DialogContext');

/** Factory function to create a new Dialog context */
export function createDialogContext(name = 'DialogContext') {
  return createContext<DialogCTX>(name);
}
